import { render, staticRenderFns } from "./TaskRoute.vue?vue&type=template&id=1ca3a5b9"
import script from "./TaskRoute.vue?vue&type=script&lang=ts"
export * from "./TaskRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca3a5b9')) {
      api.createRecord('1ca3a5b9', component.options)
    } else {
      api.reload('1ca3a5b9', component.options)
    }
    module.hot.accept("./TaskRoute.vue?vue&type=template&id=1ca3a5b9", function () {
      api.rerender('1ca3a5b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tasks/TaskRoute.vue"
export default component.exports